import React, { useContext, useState } from "react";
import AuthLayout from "../../templates/auth-templates";
import ImgLoginPanel from "../../assets/images/auth/img-auth-1.jpg";
import Logo from "../../components/Logo/Logo";
import Alert from "../../components/Alert/Alert";
import AuthContext from "../../context/AuthContext";
import { Link } from "react-router-dom";
const ResetPage = () => {
  let { errorMessage, resetPassword, passReset } = useContext(AuthContext);

  return (
    <AuthLayout>
      <div className="col-md-12">
        <div className="card-body">
          <p class="mb-3 f-w-400 text-center mb-4 mt-2 hedaer-log">
            Reset password
          </p>
          {!passReset ? (
            <form onSubmit={resetPassword}>
              <div className="form-group mb-2">
                <input
                  type="text"
                  className="form-control"
                  name="useremail"
                  placeholder="Your email"
                />
              </div>
              <button type="submit" className="btn btn-orange">
                Reset
              </button>
              <p className="mt-2 mb-2 text-muted">
                I have account?{" "}
                <Link to="/login" className="f-w-400">
                  Login
                </Link>{" "}
              </p>
            </form>
          ) : (
            <p>Please check your email.</p>
          )}
        </div>
      </div>
    </AuthLayout>
  );
};

export default ResetPage;
